@if (currentUser) {
  <fc-progress-bar currentStep="0"></fc-progress-bar>
}
<div class="container">
  <div class="main {{ currentUser ? '' : 'no-stepper' }}">
    <router-outlet></router-outlet>
  </div>
</div>
